import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";
import Tilt from "react-parallax-tilt";

import Particle from "../Particle";
import Testimonials from "./Testimonials";
import reviews from "./data";
import useInViewOnce from "../../hooks/useInViewOnce";

import techpalPortrait from "../../Assets/syep14.png";

import syepMain from "../../Assets/syepMain.png";
import cf_1 from "../../Assets/syep_2025_1.jpg";
import syep2 from "../../Assets/syep_2025_2.jpg";
import techpal1 from "../../Assets/techPal1.jpg";
import techpal2 from "../../Assets/techPal2.jpg";
import cf_2 from "../../Assets/syep_2025.jpeg";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import SlickLazyImage from "../shared/SlickLazyImage";
import { useTranslation } from "react-i18next";

const sliderImages = [
  { src: techpal1, altKey: "programs.techPal.sliderAlts.0" },
  { src: syep2, altKey: "programs.techPal.sliderAlts.1" },
  { src: techpal2, altKey: "programs.techPal.sliderAlts.2" },
  { src: syepMain, altKey: "programs.techPal.sliderAlts.3" },
  { src: cf_1, altKey: "programs.techPal.sliderAlts.4" },
  { src: cf_2, altKey: "programs.techPal.sliderAlts.5" },
];

function TechPal() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [activeSlide, setActiveSlide] = React.useState(0);

  const handleApply = () => {
    navigate("/registration#techpal-section");
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3600,
    pauseOnHover: true,
    pauseOnFocus: true,
    adaptiveHeight: false,
    lazyLoad: "progressive",
    beforeChange: (_current, next) => setActiveSlide(next),
  };

  const videoId = "5mPU-mIQgoQ";

  const { ref: topRef, hasEntered: topSeen } = useInViewOnce({ threshold: 0.18, once: true });
  const { ref: overviewRef, hasEntered: overviewSeen } = useInViewOnce({ threshold: 0.18, once: true });
  const { ref: pillarsRef, hasEntered: pillarsSeen } = useInViewOnce({ threshold: 0.18, once: true });
  const { ref: videoRef, hasEntered: videoSeen } = useInViewOnce({ threshold: 0.18, once: true });
  const { ref: testimonialsRef, hasEntered: testimonialsSeen } = useInViewOnce({ threshold: 0.18, once: true });

  const pillars = t("programs.techPal.pillars", { returnObjects: true });
  const snapshotBullets = t("programs.techPal.snapshot.bullets", { returnObjects: true });

  return (
    <Container fluid className="about-section techpal-page">
      <Particle />

      <Container className="techpal-container">
        <header className="techpal-hero">
          <h1 className="techpal-hero-title">
            {t("programs.techPal.hero.titleLeft")}<span className="purple">-</span>{t("programs.techPal.hero.titleRight")}
          </h1>
          <p className="techpal-hero-lead">
            {t("programs.techPal.hero.lead")}
          </p>
          <div className="techpal-hero-cta">
            <Button onClick={handleApply} className="custom-yellow-btn techpal-cta-btn">
              {t("common.applyNow")}
            </Button>
          </div>
        </header>

        <div ref={topRef} className={`techpal-reveal${topSeen ? " is-seen" : ""}`}>
          <Row className="techpal-top" style={{ justifyContent: "center" }}>
            <Col md={7} className="techpal-left">
              <div className="policy-card ambassadors-slider-card" aria-label={t("programs.techPal.aria.highlights")}>
                <Slider {...settings}>
                  {sliderImages.map((image, index) => (
                    <div key={index} className="ambassadors-slide">
                      <SlickLazyImage
                        src={image.src}
                        alt={t(image.altKey)}
                        className="ambassadors-slide-img"
                        index={index}
                        activeIndex={activeSlide}
                        total={sliderImages.length}
                        buffer={2}
                        eager
                      />
                    </div>
                  ))}
                </Slider>
              </div>
            </Col>

            <Col md={5} className="techpal-right">
              <div className="policy-card techpal-summary-card">
                <h2 className="techpal-card-title">{t("programs.techPal.snapshot.title")}</h2>
                <p className="about-text techpal-card-text">
                  {t("programs.techPal.snapshot.text")}
                </p>
                <ul className="techpal-bullets">
                  {Array.isArray(snapshotBullets)
                    ? snapshotBullets.map((item) => <li key={item}>{item}</li>)
                    : null}
                </ul>
                <Button onClick={handleApply} className="custom-yellow-btn techpal-cta-btn techpal-cta-btn-secondary">
                  {t("common.applyHere")}
                </Button>
              </div>
            </Col>
          </Row>
        </div>

        <section
          ref={overviewRef}
          className={`techpal-section techpal-reveal${overviewSeen ? " is-seen" : ""}`}
          aria-label={t("programs.techPal.aria.overview")}
        >
          <Row className="techpal-overview-row" style={{ justifyContent: "center" }}>
            <Col md={7} className="techpal-overview-left">
              <div className="policy-card techpal-copy-card">
                <h2 className="techpal-section-heading">{t("programs.techPal.overview.title")}</h2>
                <p className="techpal-body">{t("programs.techPal.overview.p1")}</p>
                <p className="techpal-body">{t("programs.techPal.overview.p2")}</p>
                <p className="techpal-body">{t("programs.techPal.overview.p3")}</p>
              </div>
            </Col>

            <Col md={5} className="techpal-overview-right">
              <div className="policy-card techpal-image-card techpal-image-card--side" aria-label={t("programs.techPal.aria.portrait")}>
                <Tilt glareEnable={false}>
                  <img
                    src={techpalPortrait}
                    className="img-fluid techpal-image"
                    alt={t("programs.techPal.images.portraitAlt")}
                    loading="lazy"
                    decoding="async"
                  />
                </Tilt>
              </div>
            </Col>
          </Row>
        </section>

        <section
          ref={pillarsRef}
          className={`techpal-section techpal-reveal${pillarsSeen ? " is-seen" : ""}`}
          aria-label={t("programs.techPal.aria.pillars")}
        >
          <h2 className="techpal-section-heading techpal-section-heading-center">{t("programs.techPal.pillarsTitle")}</h2>
          <p className="techpal-lead">
            {t("programs.techPal.pillarsLead")}
          </p>
          <div className="techpal-grid">
            {Array.isArray(pillars)
              ? pillars.map((pillar) => (
                  <div key={pillar.title} className="policy-card techpal-feature-card">
                    <h3 className="techpal-feature-title">{pillar.title}</h3>
                    <p className="techpal-feature-objective">
                      <strong className="purple">{t("common.objective")}:</strong> {pillar.objective}
                    </p>
                    <ul className="techpal-list">
                      {Array.isArray(pillar.bullets) ? pillar.bullets.map((item) => <li key={item}>{item}</li>) : null}
                    </ul>
                    <p className="techpal-feature-outcomes">
                      <strong className="purple">{t("common.outcomes")}:</strong> {pillar.outcomes}
                    </p>
                  </div>
                ))
              : null}
          </div>
        </section>

        <section
          ref={videoRef}
          className={`techpal-section techpal-reveal${videoSeen ? " is-seen" : ""}`}
          aria-label={t("programs.techPal.aria.video")}
        >
          <h2 className="techpal-section-heading techpal-section-heading-center">{t("common.summerInternshipProgram")}</h2>
          <div className="policy-card techpal-video-card">
            <div className="techpal-video">
              <iframe
                title={t("programs.techPal.videoIframeTitle")}
                src={`https://www.youtube.com/embed/${videoId}`}
                frameBorder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
        </section>

        <section
          ref={testimonialsRef}
          className={`techpal-testimonials-section techpal-reveal${testimonialsSeen ? " is-seen" : ""}`}
          aria-label={t("programs.techPal.aria.testimonials")}
        >
          <h2 className="techpal-section-heading techpal-section-heading-center">{t("common.testimonials")}</h2>
          <div className="impact-testimonials">
            <Testimonials reviews={reviews} />
          </div>
        </section>
      </Container>
    </Container>
  );
}

export default TechPal;


